var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保单信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.policyInfoList, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(item.key === "policyStatus" ? _vm.$t(_vm.policyInfo[item.key]) : _vm.policyInfo[item.key] || "-") + " ")])]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };